import styled from 'styled-components';
import { breakpoints } from 'theme';

export const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
  min-height: 80vh;
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  /* padding: 32px 0; */
`;

export const StyledButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  padding: 0px 20px;
`;

export const StyledPlaceholder = styled.div`
  margin-top: 30px;
  padding: 0 20px;

  h3 {
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 20px;
    color: ${({ theme }) => theme.color.pickledBluewood};
  }

  p {
    font-size: 14px;
    font-weight: 400;
  }
`;
